"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var auth_config_1 = require("../config/auth.config");
exports.default = (function (token) {
    if (!token)
        throw new Error('Missing login token');
    localStorage.setItem(auth_config_1.authConfig.tokenStorageKey, token);
});
